module.exports = __webpack_public_path__ + "img/logo-en.2fe3aabd25f9f2e9a8164403b368c435.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-en.svg
// module id = 705
// module chunks = 0